import { getRequest, severityCode } from "./httpClientUnauthorized";

const END_POINT = "info";

const getPortalApiInfo = async () => {
  return await getRequest(`${END_POINT}`);
};


const getStatusPageComponents = async () => {
  return await getRequest("StatusPage/components");
};

export { getPortalApiInfo, getStatusPageComponents, severityCode };
